import { useCallback, useState } from 'react'
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect'

export const useMediaQuery = (query: string) => {
  const [targetReached, setTargetReached] = useState(false)

  const updateTarget = useCallback((e: any) => {
    if (e.matches) setTargetReached(true)
    else setTargetReached(false)
  }, [])

  useIsomorphicLayoutEffect(() => {
    const media = window.matchMedia(query)
    media.addEventListener('change', updateTarget)

    // Check on mount (callback is not called until a change occurs)
    if (media.matches) setTargetReached(true)

    return () => media.removeEventListener('change', updateTarget)
  }, [])

  return targetReached
}

export default useMediaQuery
